import { requestApiV2, fetchStreamApi } from '@library'
import { AIAssistantSopNode, CustomerProfile, IntentionSummary, AICallSummaryData } from 'src/types/ai-assistant'

export function getAIAssistantSop (filter: { nodeId?: string; leadId?: number; cid?: string }) {
  return requestApiV2<{ node: AIAssistantSopNode }>('trpc.tcc.tcc_main.AIAssistant/GetAISop', filter)
  // const { nodeId, leadId, cid } = filter
  // return requestApiV2<{ node: AIAssistantSopNode }>('trpc.tcc.tcc_main.AIAssistant/GetAISop', {
  //   cid: '5675f3c84c2d9c26706399da39894b53',
  //   leadId: 51611883,
  //   nodeId: nodeId,
  // })
}

export function chatWithAIAssistant (filter: { type: string; content: string, reqId: string }, callbacks?: { onData: (data: any) => void, onError?: (error: any) => void, onStart?: () => void, onEnd?: () => void }) {
  const { onData, onError, onStart, onEnd } = callbacks || {}
  return fetchStreamApi('trpc.tcc.tcc_main.AIAssistant/Chat', filter, {
    onStart: () => {
      onStart && onStart()
    },
    onData: (data) => {
      onData && onData(data)
    },
    onError: (error) => {
      onError && onError(error)
    },
    onEnd: () => {
      onEnd && onEnd()
    },
  })
}

// 获取客户画像
export function getCustomerProfile (filter: { cid?: string }) {
  const { cid } = filter
  return requestApiV2<{ node: CustomerProfile }>('trpc.tcc.tcc_main.AIAssistant/CustomerProfile', { cid })
}

// 获取意向提炼
export function getIntentionSummary (filter: { leadId: number }) {
  const { leadId } = filter
  return requestApiV2('trpc.tcc.tcc_main.AIAssistant/GetIntentionSummary', { leadId })
}

// 获取 AI 通话小结
export function getAICallSummary (filter: { cid: string }) {
  return requestApiV2<AICallSummaryData>('trpc.tcc.tcc_main.Call/GetAICallSummary', filter)
}
